import React from 'react';
import ReactDOM from 'react-dom';
import { I18nLanguageSwitch } from './App';
import I18NModuleHandler from '../../utils/components/I18NModuleHandler';
function renderI18NLanguageSwitch() {
    ReactDOM.render(React.createElement(I18NModuleHandler, { loader: React.createElement(React.Fragment, null), namespace: 'i18nLanguageSwitch' },
        React.createElement(I18nLanguageSwitch, null)), document.getElementById('i18n-language-switch'));
}
window.renderI18NLanguageSwitch = renderI18NLanguageSwitch;
